export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/CBS.065c76b7.svg","height":37,"width":101};